import { gpsIntegration } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
    gpsProfileList(params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(gpsIntegration.gpsProfileBase, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },
  
    geofenceList(params = {}) {
        return new Promise((resolve, reject) => {
            axios.get(gpsIntegration.lsGeofenceBase, {
                    params: params,
                })
                .then((res) => {
                    resolve(handleResponse(res));
                })
                .catch((err) => {
                    reject(handleError(err));
                });
        });
    },

});